// @ts-strict-ignore
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'

import { logout } from '../services/logout'
import { User, UserSchema } from '../types/UserSchema'

const initialState: UserSchema = {
	isAuthorized: false,
	userData: null,
	isInited: false
}

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUserData: (state, action: PayloadAction<User>) => {
			state.userData = action.payload
		},
		setCredentials: (state, action: PayloadAction<{ ACCESS_TOKEN: string }>) => {
			Cookies.set('ACCESS_TOKEN', action.payload.ACCESS_TOKEN, { domain: '.iport.ru' })

			state.accessToken = action.payload.ACCESS_TOKEN
			state.isAuthorized = true
		},
		setIsInitedPositive: state => {
			state.isInited = true
		}
	},
	extraReducers: builder => {
		builder
			.addCase(logout.fulfilled, state => {
				Cookies.remove('ACCESS_TOKEN', { path: '/', domain: '.iport.ru' })
				state.isAuthorized = false
				state.accessToken = ''
			})
			.addCase(logout.rejected, state => {
				Cookies.remove('ACCESS_TOKEN', { path: '/', domain: '.iport.ru' })
				state.isAuthorized = false
				state.accessToken = ''
			})
	}
})

export const { actions: userActions } = userSlice
export const { reducer: userReducer } = userSlice
